// extracted by mini-css-extract-plugin
export default {"groupIconDiv":"Create&UpdateGrp_groupIconDiv__vsx+m"};